import React, {Component} from 'react'

import Registry from '../../../registry/index';

class RegisterForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formData: {
                nick: '',
                email: '',
                gender: 1,
                password: '',
                password_confirm: ''
            },
            formErrors: {},
            captchaToken: null,
            captchaError: ''
        };

        this.captchaRef = React.createRef();
        this.captchaWidgetId = null;

        this._onError = this._onError.bind(this);
        this._onSuccess = this._onSuccess.bind(this);
    }

    componentDidMount() {
        if (typeof window === 'undefined') return;

        let ageverifIntervalId = null;

        const initAgeverif = () => {
            if (window.ageverif) {
                clearInterval(ageverifIntervalId);

                if (!window.ageverif.verified) {
                    window.ageverif.start();
                }
            }
        };

        ageverifIntervalId = window.setInterval(initAgeverif, 100);

        this._ageverifCleanup = () => clearInterval(ageverifIntervalId);

        let intervalId = null;

        const initCaptcha = () => {
            if (this.captchaRef.current && window.turnstile && this.captchaWidgetId === null) {
                this.captchaWidgetId = window.turnstile.render(this.captchaRef.current, {
                    sitekey: '0x4AAAAAACYQvImRXMQ5dwGT',
                    callback: (token) => {
                        this.setState({ captchaToken: token, captchaError: '' });
                    },
                    'expired-callback': () => {
                        this.setState({ captchaToken: null });
                    }
                });

                clearInterval(intervalId);
            }
        };

        intervalId = window.setInterval(initCaptcha, 100);

        this._intervalCleanup = () => clearInterval(intervalId);
    }

    componentWillUnmount() {
        if (this._intervalCleanup) this._intervalCleanup();

        if (this._ageverifCleanup) this._ageverifCleanup();

        if (window.turnstile && this.captchaWidgetId !== null) {
            window.turnstile.remove(this.captchaWidgetId);
        }
    }

    _isAgeVerified() {
        return typeof window === 'undefined' || !window.ageverif || !!window.ageverif.verified;
    }

    sendData(e) {
        e.preventDefault();

        if (!this._isAgeVerified()) {
            window.ageverif.start();
            return;
        }

        if (!this.state.captchaToken) {
            this.setState({ captchaError: Registry.get('locale').captcha_required });
            return;
        }

        let eform = e.target.nodeName === 'FORM' ? e.target : e.target.form;
        if (eform.checkValidity()) {
            let siteInterface = Registry.get('siteInterface');
            siteInterface.register({
                ...this.state.formData,
                captcha: this.state.captchaToken,
                age_verification_token: window.ageverif && window.ageverif.verification
                    ? window.ageverif.verification.token
                    : null
            })
                .then(this._onSuccess)
                .catch(this._onError);
        }
    }

    _onSuccess(_response) {
        this.props.setInactiveEmail(this.state.formData.email)

        this.setState({
            formData: {
                nick: '',
                email: '',
                gender: 1,
                password: '',
                password_confirm: ''
            },
            formErrors: {}
        });
        this.props.switchTab(4);
    }

    _onError(exception) {
        let formErrors = exception.message;
        this.setState({
            formErrors,
            captchaToken: null
        });

        if (window.turnstile && this.captchaWidgetId !== null) {
            window.turnstile.reset(this.captchaWidgetId);
        }

        if (exception && exception.data && exception.data.type === 'ageverif' && window.ageverif) {
            window.ageverif.clear();
            window.ageverif.start();
        }
    }

    handleChange (event) {
        this.setState({
            formData: {
                ...this.state.formData,
                [event.target.name]: event.target.value
            }
        });
    }

    render() {
        let lang = Registry.get('locale');

        let {
            formData,
            formErrors
        } = this.state;

        let accordancePasswords = formData.password && formData.password_confirm && formData.password === formData.password_confirm;
        let disabledEnter = !formData.nick || !formData.email || !formData.gender || !accordancePasswords ? 'disabled' : '';

        return (
            <div className="register-form content">
                <form onSubmit={e => this.sendData(e)}>
                    <FormField errors={formErrors.nick}>
                        <input
                            name="nick"
                            type="text"
                            placeholder={lang.nick}
                            value={formData.nick}
                            onChange={e => this.handleChange(e)}
                            required
                        />
                    </FormField>
                    <FormField errors={formErrors.email}>
                        <input
                            name="email"
                            type="email"
                            placeholder={lang.email}
                            value={formData.email}
                            onChange={e => this.handleChange(e)}
                            required
                        />
                    </FormField>
                    <select
                        name="gender"
                        className="text-px-setting"
                        value={formData.gender}
                        onChange={e => this.handleChange(e)}>
                        <option value="1">{lang.male}</option>
                        <option value="2">{lang.female}</option>
                        <option value="3">{lang.couple}</option>
                        <option value="4">{lang.transvestite}</option>
                    </select>
                    <FormField errors={formErrors.password}>
                        <input
                            name="password"
                            type="password"
                            placeholder={lang.password}
                            value={formData.password}
                            onChange={e => this.handleChange(e)}
                            required
                        />
                    </FormField>
                    <FormField errors={formErrors.password_confirm}>
                        <input
                            name="password_confirm"
                            type="password"
                            placeholder={lang.password_confirm}
                            value={formData.password_confirm}
                            onChange={e => this.handleChange(e)}
                            required
                        />
                    </FormField>
                    <div ref={this.captchaRef} style={{ margin: '10px 0' }} />

                    {this.state.captchaError && (
                        <div className="form-error" style={{ marginBottom: '10px' }}>
                            {this.state.captchaError}
                        </div>
                    )}
                    <button
                        className="popup-button primary"
                        disabled={disabledEnter}
                        onClick={e => this.sendData(e)}
                    >{lang.enter}</button>
                </form>
            </div>
        )
    }
}

class FormField extends Component {
    render() {
        let {children, errors} = this.props;

        let errorsPresent = errors && errors.length;

        return (
            <div className={errorsPresent ? 'error' : ''}>
                {children}
                {(errorsPresent) ? <p>{errors[0]}</p> : null}
            </div>
        )
    }
}

export default RegisterForm;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/AnonymousLoginPopup/RegisterForm.js